/**
 * The module's permissions. Values, not types: the backend's manifest
 * registers them and the frontend gates on the same strings, so there is one
 * list.
 */
export const BOARD_PERMISSIONS = {
    /** Edit the board of a group you are a member of. */
    UPDATE: 'board.update',
};
/**
 * Bounds the server enforces, exported so a form can show them before the
 * server refuses. The server is the enforcement; these are the same numbers.
 */
export const BOARD_LIMITS = {
    /**
     * Characters, not bytes. MySQL's `text` holds 65,535 bytes and UTF-8 spends
     * up to four per character, so 16,000 always fits.
     */
    textLength: 16_000,
    /** Boards on one dashboard. A person in more groups than this sees the first by name. */
    dashboard: 50,
};
//# sourceMappingURL=board.js.map